'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLayerSpacing = exports.getLayerHeight = exports.getBarColor = undefined;

var _getBarColor = require('./getBarColor');

var _getLayerHeight = require('./getLayerHeight');

var _getLayerSpacing = require('./getLayerSpacing');

exports.getBarColor = _getBarColor.getBarColor;
exports.getLayerHeight = _getLayerHeight.getLayerHeight;
exports.getLayerSpacing = _getLayerSpacing.getLayerSpacing;